// 현재 상태를 저장 (선택되어 있는 대상 결과 등의 정보)
import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';

import * as cf from 'libs/commonFunc';
import { FormTextArea } from 'semantic-ui-react';

// action types
const INITIAL_STORE = 'currentStatus/INITIAL_STORE';
const CHANGE_PATH = 'currentStatus/CHANGE_PATH';
const CLEAR = 'currentStatus/CLEAR';
const ON_TOGGLE_MODAL = 'currentStatus/ON_TOGGLE_MODAL';
const TOGGLE_SNACKBAR = 'currentStatus/TOGGLE_SNACKBAR';
const TRIGGER_ENTER = 'currentStatus/TRIGGER_ENTER';
const ON_TOGGLE_DETAILVIEW = 'currentStatus/ON_TOGGLE_DETAILVIEW';
// 교체 페이지 정보
const PAGE_HEIGHT = 'currentStatus/PAGE_HEIGHT';
const CONTENT_PAGE_HEIGHT = 'currentStatus/CONTENT_PAGE_HEIGHT';
// 태그(tag)
const CHANGE_TAG = 'currentStatus/CHANGE_TAG';
const INITIAL_TAG = 'currentStatus/INITIAL_TAG';
const CLEAR_TAG = 'currentStatus/CLEAR_TAG';
const SELECT_TAG = 'currentStatus/SELECT_TAG';
const SELECT_LAST_TAG = 'currentStatus/SELECT_LAST_TAG';
// 대상자(target)
const CHANGE_TARGET = 'currentStatus/CHANGE_TARGET';
const CHANGE_SELECT_TARGET = 'currentStatus/CHANGE_SELECT_TARGET';
const INITIAL_TARGET = 'currentStatus/INITIAL_TARGET';
const CHECK_ALL_TARGET = 'currentStatus/CHECK_ALL_TARGET';
const CHECK_TARGET = 'currentStatus/CHECK_TARGET';
const CHECK_TARGET_MULTI = 'currentStatus/CHECK_TARGET_MULTI';
const SELECT_TARGET = 'currentStatus/SELECT_TARGET';
const CHANGE_TARGET_TAG = 'currentStatus/CHANGE_TARGET_TAG';
const CHANGE_TAG_TARGET_MODAL = 'currentStatus/CHANGE_TAG_TARGET_MODAL';
// 결과(examSummary)
const CHANGE_EXAM_SUMMARY = 'currentStatus/CHANGE_EXAM_SUMMARY';
const TOGGLE_EXAM_SUMMARY = 'currentStatus/TOGGLE_EXAM_SUMMARY';
const TOGGLE_ALL_EXAM_SUMMARY = 'currentStatus/TOGGLE_ALL_EXAM_SUMMARY';
const INITIAL_EXAM = 'currentStatus/INITIAL_EXAM';
// 결과 목록(examList)
const CHANGE_EXAM_LIST = 'currentStatus/CHANGE_EXAM_LIST';
const INITIAL_EXAM_LIST = 'currentStatus/INITIAL_EXAM_LIST';
const SELECT_EXAM_LIST = 'currentStatus/SELECT_EXAM_LIST';
const CHECK_EXAM_LIST = 'currentStatus/CHECK_EXAM_LIST';
const CHECK_EXAM_LIST_MULTI = 'currentStatus/CHECK_EXAM_LIST_MULTI';
const CHECK_ALL_EXAM_LIST = 'currentStatus/CHECK_ALL_EXAM_LIST';
// 교육하기(edu)
const CHANGE_EDU_NO = 'currentStatus/CHANGE_EDU_NO';
const CHANGE_EDU = 'currentStatus/CHANGE_EDU';
const CHANGE_EDU_TARGET_NO = 'currentStatus/CHANGE_EDU_TARGET_NO';
const CHANGE_EDU_EXAM = 'currentStatus/CHANGE_EDU_EXAM';
const SELECT_EDU_NO = 'currentStatus/SELECT_EDU_NO';
const SELECT_EDIT_EDU_NO = 'currentStatus/SELECT_EDIT_EDU_NO';
const SELECT_EDU_TARGET_NO = 'currentStatus/SELECT_EDU_TARGET_NO';
const SELECT_EDU_EXAM = 'currentStatus/SELECT_EDU_EXAM';
// 신고하기(declare)
const INITIAL_DECLARE_TARGET = 'currentStatus/INITIAL_DECLARE_TARGET';
const SELECT_DECLARE_TARGET_NO = 'currentStatus/SELECT_DECLARE_TARGET_NO';
const SELECT_DECLARE_NO = 'currentStatus/SELECT_DECLARE_NO';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changePath = createAction(CHANGE_PATH);
export const clear = createAction(CLEAR);
export const onToggleModal = createAction(ON_TOGGLE_MODAL);
export const toggleSnackbar = createAction(TOGGLE_SNACKBAR);
export const triggerEnter = createAction(TRIGGER_ENTER);
export const onToggleDetailView = createAction(ON_TOGGLE_DETAILVIEW);
// 교체 페이지 정보
export const pageHeight = createAction(PAGE_HEIGHT);
export const contentPageHeight = createAction(CONTENT_PAGE_HEIGHT);
// 태그(tag)
export const changeTag = createAction(CHANGE_TAG);
export const initialTag = createAction(INITIAL_TAG);
export const clearTag = createAction(CLEAR_TAG);
export const selectTag = createAction(SELECT_TAG);
export const selectLastTag = createAction(SELECT_LAST_TAG);
// 대상자(target)
export const changeTarget = createAction(CHANGE_TARGET);
export const changeSelectTarget = createAction(CHANGE_SELECT_TARGET);
export const initialTarget = createAction(INITIAL_TARGET);
export const checkAllTarget = createAction(CHECK_ALL_TARGET);
export const checkTarget = createAction(CHECK_TARGET);
export const checkTargetMulti = createAction(CHECK_TARGET_MULTI);
export const selectTarget = createAction(SELECT_TARGET);
export const changeTargetTag = createAction(CHANGE_TARGET_TAG);
export const changeTargetTagModal = createAction(CHANGE_TAG_TARGET_MODAL);
// 결과(examSummary)
export const changeExamSummary = createAction(CHANGE_EXAM_SUMMARY);
export const toggleExamSummary = createAction(TOGGLE_EXAM_SUMMARY);
export const toggleAllExamSummary = createAction(TOGGLE_ALL_EXAM_SUMMARY);
export const initialExam = createAction(INITIAL_EXAM);
// 결과 목록(examList)
export const changeExamList = createAction(CHANGE_EXAM_LIST);
export const initialExamList = createAction(INITIAL_EXAM_LIST);
export const selectExamList = createAction(SELECT_EXAM_LIST);
export const checkExamList = createAction(CHECK_EXAM_LIST);
export const checkExamListMulti = createAction(CHECK_EXAM_LIST_MULTI);
export const checkAllExamList = createAction(CHECK_ALL_EXAM_LIST);
// 교육하기(edu)
export const changeEduNo = createAction(CHANGE_EDU_NO);
export const changeEdu = createAction(CHANGE_EDU);
export const changeEduTargetNo = createAction(CHANGE_EDU_TARGET_NO);
export const changeEduExam = createAction(CHANGE_EDU_EXAM);
export const selectEduNo = createAction(SELECT_EDU_NO);
export const selectEditEduNo = createAction(SELECT_EDIT_EDU_NO);
export const selectEduTargetNo = createAction(SELECT_EDU_TARGET_NO);
export const selectEduExamNo = createAction(SELECT_EDU_EXAM);
// 신고하기(declare)
export const initialDeclareTarget = createAction(INITIAL_DECLARE_TARGET);
export const selectDeclareTargetNo = createAction(SELECT_DECLARE_TARGET_NO);
export const selectDeclareNo = createAction(SELECT_DECLARE_NO);

// initial state
const initialState = Map({
  path: Map({
    current: '',
    before: ''
  }),
  // 엔터 입력시 저장 처리를 위한 전달값
  isEditSubmit: '',
  // 모달 view
  isModal: '',
  // snackBar(우측상단에 알림창)
  isSnackbar: '',
  // 우측의 상세보기 표시/숨김
  isDetailView: true,
  // 교체 페이지 정보
  etc: fromJS({
    pageHeight: 0,
    contentPageHeight: 0
  }),
  // 태그
  tag: Map({
    selectedTag: List(['all-tag']),
    multiType: 'or',
    isMultiSelect: false,
    isMultiAndSelect: false,
    isEditData: Map({
      tagNo: 0,
      tagName: '',
      tagInitial: '',
      createUser: 0,
      color: ''
    }),
    isDropdown: Map({
      isView: false,
      top: 0,
      left: 0
    }),
    // 태그의 검색 내용
    searchText: '',
    isTagNameEdit: false,
    isOpen: List([]),
    isEditMode: false
  }),
  // 대상자
  target: Map({
    selectTarget: Map({
      isAllCheckTarget: 0, // 0 - 체크 안됨, 1 - 현재 리스트, 2 - 모두 선택(모든 대상자 선택) 3 - 일부 선택
      isType: '', // select - 선택, check - 체크
      targetNoArray: List([]),
      lastCheck: 0 // 가장 마지막에 체크한 대상자 번호
    }),
    isEditType: '',
    isEditData: Map({}),
    tagTarget: Map({})
  }),
  // 결과 목록(examSummary)
  examSummary: Map({
    // 결과 검색 활성화
    isSearchActive: false,
    // 이전에 선택한 훈련
    before: 'all',
    // 위험대상자가 있는 훈련 보기
    isInfection: false,
    // 훈련의 검색 내용
    searchText: '',
    // 선택한 결과 정보 (default는 전체 훈련)
    selected: 'all',
    isOpen: List([])
  }),
  // 결과 목록(examList)
  examList: Map({
    // 선택한 결과
    selected: Map({
      isAllCheckExamList: 0, // 전체 선택: 0 - 체크 안됨, 1 - 전체 선택(현재 리스트), 2 - 모두 선택(모든 대상자 선택)
      isType: '',
      noArray: List([]),
      lastCheck: 0 // 가장 마지막에 체크한 훈련 번호
    })
  }),
  // 교육 관리
  edu: Map({
    // 선택한 교육 (default는 전체)
    selectEduNo: 'all',
    selectEditEduNo: 0,
    selectEduTargetNo: 0,
    selectEduExamNoArray: List([]),
    // 결과 검색 활성화
    isSearchActive: false,
    // 검색
    searchText: ''
  }),
  // 신고 관리
  declare: Map({
    selectDeclareExamNo: 0,
    selectDeclareTargetNo: 0,
    selectDeclareNo: 0
  })
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    //
    [CHANGE_PATH]: (state, action) => {
      const { path, beforePath } = action.payload;

      return state.setIn(['path', 'current'], path).setIn(['path', 'before'], beforePath);
    },
    // 드랍다운, 수정상태 등 초기화
    [CLEAR]: (state, action) => {
      return state
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false)
        .setIn(['target', 'isEditType'], '')
        .setIn(['target', 'isEditData'], Map({}));
    },
    // 모달 open/close 처리
    [ON_TOGGLE_MODAL]: (state, action) => {
      const { viewType } = action.payload;

      return state
        .set('isModal', viewType)
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false);
    },
    // 모달 open/close 처리
    [TOGGLE_SNACKBAR]: (state, action) => {
      const { message } = action.payload;

      return state.set('isSnackbar', message);
    },
    // TRIGGER_ENTER MainPage에서 엔터 처리를 위해서 넘겨주는 값
    [TRIGGER_ENTER]: (state, action) => {
      const { bool } = action.payload;
      return state.set('isEditSubmit', bool);
    },
    // 우측의 상세보기 표시/숨김
    [ON_TOGGLE_DETAILVIEW]: (state, action) => {
      return state.set('isDetailView', !state.get('isDetailView'));
    },
    // -------------------------- 교체 페이지 정보 --------------------------
    [PAGE_HEIGHT]: (state, action) => {
      const height = action.payload;
      return state.setIn(['etc', 'pageHeight'], height);
    },
    [CONTENT_PAGE_HEIGHT]: (state, action) => {
      const height = action.payload;
      return state.setIn(['etc', 'contentPageHeight'], height);
    },
    // -------------------------- 태그(tag) --------------------------
    // 현재 선택된 태그 정보 변경(수정)
    [CHANGE_TAG]: (state, action) => {
      const { name, value } = action.payload;
      return state.setIn(['tag', name], value);
    },
    // 현재 선택된 태그 정보 변경
    [INITIAL_TAG]: (state, action) => {
      return state.set('tag', initialState.get('tag'));
    },
    // 선택태그를 제외한 나머지 초기화
    [CLEAR_TAG]: (state, action) => {
      return state.setIn(['tag', 'isDropdown', 'isView'], false).setIn(['tag', 'isTagNameEdit'], false);
    },
    // 태그 클릭시 처리
    [SELECT_TAG]: (state, action) => {
      const { tagNo, isMultiSelect, isMultiAndSelect } = action.payload;
      let selectedTag = state.getIn(['tag', 'selectedTag']);

      // 태그 단일 선택
      if (!isMultiSelect && !isMultiAndSelect) {
        return state.setIn(['tag', 'selectedTag'], List([tagNo]));

        // 태그 다중 선택
      } else {
        // 모든대상자 / 태그가 없는 대상자 였을 경우 지워주기
        if (selectedTag.indexOf('all-tag') !== -1 || selectedTag.indexOf('no-tag') !== -1) {
          selectedTag = List([]);
        }

        const index = selectedTag.indexOf(tagNo);
        // 태그 해제
        if (index !== -1) {
          // 태그 해제시 마지막 태그를 해제 할 경우 모든 대상자를 선택 처리 해줘야 한다
          return selectedTag.size === 1
            ? state.setIn(['tag', 'selectedTag'], List(['all-tag']))
            : state.setIn(['tag', 'selectedTag'], selectedTag.splice(index, 1));
          // 태그 선택
        } else {
          return state.setIn(['tag', 'selectedTag'], selectedTag.push(tagNo));
        }
      }
    },
    // 가장 마지막에 선택한 태그 클릭
    [SELECT_LAST_TAG]: (state, action) => {
      const lastTag = state.getIn(['tag', 'selectedTag']).get(-1);
      return state.setIn(['tag', 'selectedTag'], List([lastTag]));
    },
    // -------------------------- 대상자(target) --------------------------
    // 현재 선택된 대상자 정보 변경
    [CHANGE_TARGET]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['target', name], value);
    },
    [CHANGE_SELECT_TARGET]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['target', 'selectTarget', name], value);
    },
    // 현재 선택된 대상자 정보 변경
    [INITIAL_TARGET]: (state, action) => {
      return state.set('target', initialState.get('target'));
    },
    // 대상자 전체 체크
    [CHECK_ALL_TARGET]: (state, action) => {
      // 대상자 수정 초기화
      state = state
        .set('isDetailView', true)
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false)
        .setIn(['target', 'isEditType'], '')
        .setIn(['target', 'isEditData'], Map({}));

      const { targetNoArray, isAllCheckTarget } = action.payload;

      // 0 - 체크 안됨, 1 - 현재 리스트, 2 - 모두 선택(모든 대상자 선택) 3 - 일부 선택
      state = state.setIn(['target', 'selectTarget', 'isAllCheckTarget'], isAllCheckTarget);

      // 해제
      if (isAllCheckTarget === 0) {
        return state
          .setIn(['target', 'selectTarget', 'isType'], '')
          .setIn(['target', 'selectTarget', 'targetNoArray'], List([]));
        // 전체 선택(현재 리스트)
      } else if (isAllCheckTarget === 1) {
        return state
          .setIn(['target', 'selectTarget', 'isType'], 'check')
          .setIn(['target', 'selectTarget', 'targetNoArray'], List(targetNoArray));
        // 모두 선택
      } else if (isAllCheckTarget === 2) {
        return state.setIn(['target', 'selectTarget', 'isType'], 'check');
        // 일부 선택
      } else if (isAllCheckTarget === 3) {
        return state
          .setIn(['target', 'selectTarget', 'isType'], 'check')
          .setIn(['target', 'selectTarget', 'targetNoArray'], List(targetNoArray));
      }
    },
    // 대상자 체크
    [CHECK_TARGET]: (state, action) => {
      // 대상자 수정 초기화
      state = state
        .set('isDetailView', true)
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false)
        .setIn(['target', 'isEditType'], '')
        .setIn(['target', 'isEditData'], Map({}));

      if (state.getIn(['target', 'selectTarget', 'isType']) === 'select') {
        state = state.setIn(['target', 'selectTarget', 'targetNoArray'], List([]));
      }

      const { targetNo, totalTarget } = action.payload;
      const targetNoArray = state.getIn(['target', 'selectTarget', 'targetNoArray']);
      const index = targetNoArray.indexOf(targetNo);

      state = state.setIn(['target', 'selectTarget', 'lastCheck'], targetNo);

      // 대상자 해제
      if (index !== -1) {
        // 마지막 체크를 지우면 '전체체크 버튼' 해제
        if (targetNoArray.size === 1) {
          state = state
            .setIn(['target', 'selectTarget', 'isType'], '')
            .setIn(['target', 'selectTarget', 'targetNoArray'], List([]))
            .setIn(['target', 'selectTarget', 'isAllCheckTarget'], 0);
        } else {
          state = state
            .setIn(['target', 'selectTarget', 'targetNoArray'], targetNoArray.splice(index, 1))
            .setIn(['target', 'selectTarget', 'isAllCheckTarget'], 3);
        }
        return state;
        // 대상자 체크
      } else {
        // 0 - 체크 안됨, 1 - 현재 리스트 2 - 모두 선택(모든 대상자 선택) 3 - 일부 선택
        // 전체 선택
        if (targetNoArray.size + 1 === totalTarget) {
          state = state.setIn(['target', 'selectTarget', 'isAllCheckTarget'], 1);
        } else {
          state = state.setIn(['target', 'selectTarget', 'isAllCheckTarget'], 3);
        }

        return state
          .setIn(['target', 'selectTarget', 'isType'], 'check')
          .setIn(['target', 'selectTarget', 'targetNoArray'], targetNoArray.push(targetNo));
      }
    },
    // 대상자 멀티 선택
    [CHECK_TARGET_MULTI]: (state, action) => {
      // 대상자 수정 초기화
      state = state
        .set('isDetailView', true)
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false)
        .setIn(['target', 'isEditType'], '')
        .setIn(['target', 'isEditData'], Map({}));

      if (state.getIn(['target', 'selectTarget', 'isType']) === 'select') {
        state = state.setIn(['target', 'selectTarget', 'targetNoArray'], List([]));
      }

      const { targetNo, targetArray, isRemove, totalTarget } = action.payload;

      state = state.setIn(['target', 'selectTarget', 'lastCheck'], targetNo);

      let afterTarget = state.getIn(['target', 'selectTarget', 'targetNoArray']);

      // 대상자 해제
      if (isRemove) {
        for (let i = 0, l = targetArray.length; i < l; i++) {
          const index = afterTarget.indexOf(targetArray[i]);
          if (index !== -1) {
            afterTarget = afterTarget.splice(index, 1);
          }
        }

        state = state
          .setIn(['target', 'selectTarget', 'targetNoArray'], afterTarget)
          .setIn(['target', 'selectTarget', 'isAllCheckTarget'], 3);
        // 대상자 추가
      } else {
        for (let i = 0, l = targetArray.length; i < l; i++) {
          const isExist = afterTarget.indexOf(targetArray[i]) !== -1 ? true : false;
          if (!isExist) {
            afterTarget = afterTarget.push(targetArray[i]);
          }
        }
        state = state
          .setIn(['target', 'selectTarget', 'isType'], 'check')
          .setIn(['target', 'selectTarget', 'targetNoArray'], afterTarget);
      }

      // 0 - 체크 안됨, 1 - 현재 리스트 2 - 모두 선택(모든 대상자 선택) 3 - 일부 선택
      // 마지막 체크를 지우면 '전체체크 버튼' 해제
      if (afterTarget.size === 0) {
        state = state
          .setIn(['target', 'selectTarget', 'isType'], '')
          .setIn(['target', 'selectTarget', 'targetNoArray'], List([]))
          .setIn(['target', 'selectTarget', 'isAllCheckTarget'], 0);

        // 전체 선택
      } else if (afterTarget.size === totalTarget) {
        state = state.setIn(['target', 'selectTarget', 'isAllCheckTarget'], 1);
      } else {
        state = state.setIn(['target', 'selectTarget', 'isAllCheckTarget'], 3);
      }

      return state;
    },
    // 대상자 선택
    [SELECT_TARGET]: (state, action) => {
      // 대상자 수정 초기화
      state = state
        .set('isDetailView', true)
        .setIn(['tag', 'isDropdown', 'isView'], false)
        .setIn(['tag', 'isTagNameEdit'], false)
        .setIn(['target', 'isEditType'], '')
        .setIn(['target', 'isEditData'], Map({}))
        .setIn(['target', 'selectTarget', 'isAllCheckTarget'], 0);

      const { targetNo } = action.payload;

      return state
        .setIn(['target', 'selectTarget', 'isType'], 'select')
        .setIn(['target', 'selectTarget', 'targetNoArray'], List([targetNo]));
    },
    // 단일 대상자의 태그 정보 수정
    [CHANGE_TARGET_TAG]: (state, action) => {
      const { tagNames } = action.payload;

      return state.setIn(['target', 'isEditData', 'targetTag'], tagNames);
    },
    // (모달) 다중 대상자의 태그 정보 수정
    [CHANGE_TAG_TARGET_MODAL]: (state, action) => {
      const { tagNoArray } = action.payload;

      return state.setIn(['target', 'tagTarget'], tagNoArray);
    },
    // -------------------------- 결과(examSummray) --------------------------
    [CHANGE_EXAM_SUMMARY]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['examSummary', name], value);
    },
    // 결과 요약 펼치기
    [TOGGLE_EXAM_SUMMARY]: (state, action) => {
      const { examNo } = action.payload;
      const openList = state.getIn(['examSummary', 'isOpen']);
      const index = openList.indexOf(examNo);

      if (index !== -1) {
        return state.setIn(['examSummary', 'isOpen'], openList.splice(index, 1));
      } else {
        return state.setIn(['examSummary', 'isOpen'], openList.push(examNo));
      }
    },
    // 결과 요약 전체 펼치기
    [TOGGLE_ALL_EXAM_SUMMARY]: (state, action) => {
      const { examNoArray } = action.payload;

      state = state.setIn(['examSummary', 'isOpen'], List([]));

      if (!!state.getIn(['examSummary', 'isAllOpen'])) {
        return state.setIn(['examSummary', 'isAllOpen'], false);
      } else {
        return state.setIn(['examSummary', 'isAllOpen'], true).setIn(['examSummary', 'isOpen'], examNoArray);
      }
    },
    // 현재 선택된 결과 정보 변경
    [INITIAL_EXAM]: (state, action) => {
      return state.set('examSummary', initialState.get('exam'));
    },
    // -------------------------- 결과 목록(examList) --------------------------
    // 훈련 목록 수정
    [CHANGE_EXAM_LIST]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['examList', name], value);
    },
    // 훈련 목록 수정
    [INITIAL_EXAM_LIST]: (state, action) => {
      return state.set('examList', initialState.get('examList'));
    },
    // 훈련 목록 선택
    [SELECT_EXAM_LIST]: (state, action) => {
      const { selectNo } = action.payload;
      const noArray = state.getIn(['examList', 'selected', 'noArray']);
      const isType = state.getIn(['examList', 'selected', 'isType']);
      const index = noArray.indexOf(selectNo);
      state = state.set('isDetailView', true).setIn(['examList', 'selected', 'isAllCheckExamList'], 0);

      // 이전에 check이면 전부 삭제 후 등록
      if (isType === 'check' || index === -1) {
        return state
          .setIn(['examList', 'selected', 'isType'], 'select')
          .setIn(['examList', 'selected', 'noArray'], List([selectNo]));
      } else {
        return state
          .setIn(['examList', 'selected', 'isType'], '')
          .setIn(['examList', 'selected', 'noArray'], noArray.splice(index, 1));
      }
    },
    // 훈련 목록 선택
    [CHECK_EXAM_LIST]: (state, action) => {
      const { selectNo, totalExamList } = action.payload;
      const noArray = state.getIn(['examList', 'selected', 'noArray']);
      const isType = state.getIn(['examList', 'selected', 'isType']);
      const index = noArray.indexOf(selectNo);
      state = state.set('isDetailView', true).setIn(['examList', 'selected', 'lastCheck'], selectNo);

      // 이전에 select이면 전부 삭제 후 등록
      if (isType === 'select') {
        return state
          .setIn(['examList', 'selected', 'isType'], 'check')
          .setIn(['examList', 'selected', 'noArray'], List([selectNo]));
      }

      if (index !== -1) {
        // 마지막 체크를 지우면 '전체체크 버튼' 해제
        if (noArray.size === 1) {
          state = state
            .setIn(['examList', 'selected', 'isType'], '')
            .setIn(['examList', 'selected', 'noArray'], List([]))
            .setIn(['examList', 'selected', 'isAllCheckExamList'], 0);
        } else {
          state = state
            .setIn(['examList', 'selected', 'noArray'], noArray.splice(index, 1))
            .setIn(['examList', 'selected', 'isAllCheckExamList'], 3);
        }

        return state;
      } else {
        // 전체 선택
        if (noArray.size + 1 === totalExamList) {
          state = state.setIn(['examList', 'selected', 'isAllCheckExamList'], 1);
        } else {
          state = state.setIn(['examList', 'selected', 'isAllCheckExamList'], 3);
        }

        return state
          .setIn(['examList', 'selected', 'isType'], 'check')
          .setIn(['examList', 'selected', 'noArray'], noArray.unshift(selectNo));
      }
    },
    // 훈련 목록 선택
    [CHECK_EXAM_LIST_MULTI]: (state, action) => {
      const { selectNo, examArray, isRemove, totalExamList } = action.payload;
      const isType = state.getIn(['examList', 'selected', 'isType']);
      state = state.set('isDetailView', true);

      // 이전에 select이면 전부 삭제 후 등록
      if (isType === 'select') {
        state = state
          .setIn(['examList', 'selected', 'isType'], 'check')
          .setIn(['examList', 'selected', 'noArray'], List([]));
      }

      state = state.setIn(['examList', 'selected', 'lastCheck'], selectNo);

      let afterExam = state.getIn(['examList', 'selected', 'noArray']);

      if (isRemove) {
        for (let i = 0, l = examArray.length; i < l; i++) {
          const index = afterExam.indexOf(examArray[i]);
          if (index !== -1) {
            afterExam = afterExam.splice(index, 1);
          }
        }

        state = state
          .setIn(['examList', 'selected', 'noArray'], afterExam)
          .setIn(['examList', 'selected', 'isAllCheckExamList'], 0);
        // 훈련 추가
      } else {
        for (let i = 0, l = examArray.length; i < l; i++) {
          const isExist = afterExam.indexOf(examArray[i]) !== -1 ? true : false;
          if (!isExist) {
            afterExam = afterExam.push(examArray[i]);
          }
        }
        state = state
          .setIn(['examList', 'selected', 'isType'], 'check')
          .setIn(['examList', 'selected', 'noArray'], afterExam);
      }

      // 0 - 체크 안됨, 1 - 현재 리스트  3 - 일부 선택
      // 마지막 체크를 지우면 '전체체크 버튼' 해제
      if (afterExam.size === 0) {
        state = state
          .setIn(['examList', 'selected', 'isType'], '')
          .setIn(['examList', 'selected', 'noArray'], List([]))
          .setIn(['examList', 'selected', 'isAllCheckExamList'], 0);

        // 전체 선택
      } else if (afterExam.size === totalExamList) {
        state = state.setIn(['examList', 'selected', 'isAllCheckExamList'], 1);
      } else {
        state = state.setIn(['examList', 'selected', 'isAllCheckExamList'], 3);
      }

      return state;
    },
    // 훈련 전체 체크
    [CHECK_ALL_EXAM_LIST]: (state, action) => {
      const { noArray, isAllCheckExamList } = action.payload;

      // 해제 -> 전체 선택
      if (isAllCheckExamList === 1) {
        return state
          .setIn(['examList', 'selected', 'isType'], 'check')
          .setIn(['examList', 'selected', 'isAllCheckExamList'], isAllCheckExamList)
          .setIn(['examList', 'selected', 'noArray'], List(noArray));
        // 전체선택 -> 해제
      } else {
        return state
          .setIn(['examList', 'selected', 'isType'], '')
          .setIn(['examList', 'selected', 'isAllCheckExamList'], isAllCheckExamList)
          .setIn(['examList', 'selected', 'noArray'], List([]));
      }
    },
    // ---------------------------- 교육하기 ----------------------------
    [CHANGE_EDU_NO]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['edu', name], value).setIn(['edu', 'selectEduTargetNo'], 0);
    },
    [CHANGE_EDU]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['edu', name], value);
    },
    [CHANGE_EDU_TARGET_NO]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['edu', name], value);
    },
    [CHANGE_EDU_EXAM]: (state, action) => {
      const { selectEduExamNoArray } = action.payload;

      return state.setIn(['edu', 'selectEduExamNoArray'], selectEduExamNoArray);
    },
    // 상세 정보 확인할 교육 선택
    [SELECT_EDU_NO]: (state, action) => {
      const { eduNo } = action.payload;

      return state.setIn(['edu', 'selectEduNo'], eduNo);
    },
    // 수정 또는 삭제할 교육 선택
    [SELECT_EDIT_EDU_NO]: (state, action) => {
      const { eduNo } = action.payload;

      return state.setIn(['edu', 'selectEditEduNo'], eduNo);
    },
    // 교육 대상자 선택
    [SELECT_EDU_TARGET_NO]: (state, action) => {
      const { eduTargetNo } = action.payload;

      return state.setIn(['edu', 'selectEduTargetNo'], eduTargetNo);
    },
    // 훈련 정보 수정
    [SELECT_EDU_EXAM]: (state, action) => {
      const { examNoArray } = action.payload;

      return state.setIn(['edu', 'selectEduExamNoArray'], examNoArray);
    },
    // ---------------------------- 신고하기 ----------------------------
    //
    [INITIAL_DECLARE_TARGET]: (state, action) => {
      return state.set('declare', initialState.get('declare'));
    },
    // 신고하기 대상자 선택
    [SELECT_DECLARE_TARGET_NO]: (state, action) => {
      const { declareTargetNo } = action.payload;

      return state.setIn(['declare', 'selectDeclareTargetNo'], declareTargetNo);
    },
    // 신고하기 선택
    [SELECT_DECLARE_NO]: (state, action) => {
      const { declareNo } = action.payload;

      return state.setIn(['declare', 'selectDeclareNo'], declareNo);
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/currentStatus.js